import { yup } from '@guiker/yup-util'

export const createListingSchema = yup.object({})

export type CreateListingSchema = yup.InferType<typeof createListingSchema>
